module.exports = __webpack_public_path__ + "static/dataportal-3a75fc426987963ef583fbba46f0ecbc.jpg";